import {
  __export,
  __reExport
} from "./chunk-IEP6GGEX.mjs";

// ../../../node_modules/.pnpm/@effect+sql-sqlite-wasm@0.52.0_@effect+experimental@0.60.0_@effect+platform@0.96.2_effe_0855b018046009fc0ff8592af8c6f7c3/node_modules/@effect/sql-sqlite-wasm/dist/esm/SqliteMigrator.js
var SqliteMigrator_exports = {};
__export(SqliteMigrator_exports, {
  layer: () => layer,
  run: () => run
});
__reExport(SqliteMigrator_exports, Migrator_star);
import * as Migrator from "@effect/sql/Migrator";
import * as Layer from "effect/Layer";
import * as Migrator_star from "@effect/sql/Migrator";
var run = /* @__PURE__ */ Migrator.make({});
var layer = (options) => Layer.effectDiscard(run(options));

export {
  run,
  layer,
  SqliteMigrator_exports
};
//# sourceMappingURL=chunk-U52CC52Z.mjs.map
